let itm = {
  bcg: require('./bcg_karty.png'),
  animals: require('./kar/bcg_anim_t.png'),
  items: [
    {
      // disable: true,
      bcg: require('./kar/bcg_k.png'),
      cssStyle: {
        position: 'absolute',
        top: '31.4%',
        left: '2.4%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '27%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u1',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./kar/bcg_k2.png'),
      cssStyle: {
        position: 'absolute',
        top: '31.4%',
        left: '16.2%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k2.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '26.5%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u2',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./kar/bcg_k3.png'),
      cssStyle: {
        position: 'absolute',
        top: '31.4%',
        left: '30%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k3.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '26.5%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u3',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./kar/bcg_k4.png'),
      cssStyle: {
        position: 'absolute',
        top: '31.4%',
        left: '43.8%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k4.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '27%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u4',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./kar/bcg_k5.png'),
      cssStyle: {
        position: 'absolute',
        top: '31.4%',
        left: '57.5%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k5.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '27%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u5',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./kar/bcg_k6.png'),
      cssStyle: {
        position: 'absolute',
        top: '31.4%',
        left: '71.3%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k6.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '27%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u6',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./kar/bcg_k7.png'),
      cssStyle: {
        position: 'absolute',
        top: '31.4%',
        left: '85.1%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k7.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '27%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u7',
          type: 'karta',
        },
      ],
    },
    //
    {
      // disable: true,
      bcg: require('./kar/bcg_k8.png'),
      cssStyle: {
        position: 'absolute',
        top: '57.2%',
        left: '2.3%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k8.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '27%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u8',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./kar/bcg_k9.png'),
      cssStyle: {
        position: 'absolute',
        top: '57.2%',
        left: '16.2%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k9.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '27%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u9',
          type: 'karta',
        },
      ],
    },
    {
      // disable: true,
      bcg: require('./kar/bcg_k10.png'),
      cssStyle: {
        position: 'absolute',
        top: '57.2%',
        left: '30%',
        height: '22%',
        width: '12%',
      },
      elem: [
        {
          bcg: require('./kar/k10.png'),
          cssStyle: {
            position: 'absolute',
            top: '34.5%',
            left: '27%',
            height: '64.5%',
            width: '46.5%',
          },
          redirect: '0/u10',
          type: 'karta',
        },
      ],
    },
    //
    {
      // disable: true,
      bcg: require('./kar/bcg_k_fes.png'),
      cssStyle: {
        position: 'absolute',
        top: '57.4%',
        left: '57%',
        height: '26.2%',
        width: '40.4%',
      },
      elem: [
        {
          bcg: require('./kar/k_ch.png'),
          cssStyle: {
            position: 'absolute',
            top: '45.5%',
            left: '8%',
            height: '52%',
            width: '13%',
          },
          redirect: '0/u11',
          type: 'karta',
        },
        {
          bcg: require('./kar/k_car.png'),
          cssStyle: {
            position: 'absolute',
            top: '45.5%',
            left: '31.5%',
            height: '52%',
            width: '13%',
          },
          redirect: '0/u12',
          type: 'karta',
        },
        {
          bcg: require('./kar/k_piz.png'),
          cssStyle: {
            position: 'absolute',
            top: '45.5%',
            left: '55.5%',
            height: '52%',
            width: '13%',
          },
          redirect: '0/u13',
          type: 'karta',
        },
        {
          bcg: require('./kar/k_e.png'),
          cssStyle: {
            position: 'absolute',
            top: '45.5%',
            left: '79.5%',
            height: '52%',
            width: '13%',
          },
          redirect: '0/u14',
          type: 'karta',
        },
      ],
    },
  ],
};

export default itm;
